import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import MiniLoader from './miniLoader';
import Ending from './ending';
let scrollPos = 0;
const MenuList = ({
  children,
  pageNext: _pageNext = null,
  hasNext: _hasNext = false,
  isLoading: _isLoading = false,
  endMessage: _endMessage = null
}) => {
  const onScroll = event => {
    const newPos = event.target.scrollTop;
    if (newPos !== 0) {
      scrollPos = newPos;
    }
  };
  const hasMore = _pageNext && _hasNext;
  const ending = /*#__PURE__*/React.createElement(Ending, {
    endingMessage: _endMessage,
    isLoading: _isLoading
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "scroll-target",
    className: "t-select-menulist-container",
    style: {
      maxHeight: '300px',
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    dataLength: children.length || 0,
    next: _pageNext,
    scrollableTarget: "scroll-target",
    style: {
      overflow: 'hidden'
    },
    initialScrollY: scrollPos,
    hasMore: hasMore,
    loader: /*#__PURE__*/React.createElement(MiniLoader, null),
    onScroll: onScroll,
    endMessage: ending
  }, children));
};
MenuList.propTypes = {
  children: PropTypes.node.isRequired,
  pageNext: PropTypes.func,
  isLoading: PropTypes.bool,
  hasNext: PropTypes.bool,
  endMessage: PropTypes.string
};
export default MenuList;